import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=6bac215b&scoped=true&"
import script from "./trash.vue?vue&type=script&lang=js&"
export * from "./trash.vue?vue&type=script&lang=js&"
import style0 from "./trash.vue?vue&type=style&index=0&id=6bac215b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bac215b",
  null
  
)

export default component.exports